import { Component, Input } from '@angular/core';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

const SAMPLE_METHOD_NAME = 'Ground Shipping';
const SAMPLE_PRICE: number = 5.99;

@Component({
  selector: 'shipping-method-line-component-preview',
  templateUrl: './shipping-method-line-component-preview.component.html',
  styleUrls: ['./shipping-method-line-component-preview.component.scss'],
  standalone: false,
})
export class ShippingMethodLineComponentPreviewComponent {
  @Input() options: ShopPlugin.ProductPagePromise.ShippingMethodLineOptions;
  @Input() zipCodeAvailable = true;

  get methodName(): string {
    return SAMPLE_METHOD_NAME;
  }

  get priceLabel(): string | null {
    if (
      this.options?.priceDisplay !== ShopPlugin.ProductPagePromise.ShippingMethodLinePriceDisplay.ABSOLUTE_IN_BRACKETS
    ) {
      return null;
    }
    if (SAMPLE_PRICE === 0) return '(Free)';
    return `($${SAMPLE_PRICE.toFixed(2)})`;
  }

  get showChangeButton(): boolean {
    return !!this.options?.allowShopperToChangeMethod;
  }

  get buttonLabelHtml(): string {
    return this.options?.buttonLabel ?? '';
  }
}
